export default {
  setCPF: function (cpf) {
    try {
      if (cpf) {
        localStorage.setItem("@cpf_estou_aqui", cpf);
      }
      return true;
    } catch (error) {
      return false;
    }
  },


  getCPF: function () {
    try {
      return localStorage.getItem("@cpf_estou_aqui");
    } catch (error) {
      return false;
    }
  },
}